var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 24C15.7 23.9995 17.9984 23.2072 19.8627 21.7493L25.724 27.6107L27.6093 25.7253L21.748 19.864C23.2067 17.9996 23.9994 15.7006 24 13.3333C24 7.45201 19.2147 2.66667 13.3333 2.66667C7.452 2.66667 2.66667 7.45201 2.66667 13.3333C2.66667 19.2147 7.452 24 13.3333 24ZM13.3333 5.33334C17.7453 5.33334 21.3333 8.92134 21.3333 13.3333C21.3333 17.7453 17.7453 21.3333 13.3333 21.3333C8.92134 21.3333 5.33334 17.7453 5.33334 13.3333C5.33334 8.92134 8.92134 5.33334 13.3333 5.33334Z",
    fill: "#68507C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.216 11.448C15.7213 11.9547 16 12.624 16 13.3333H18.6667C18.6679 12.6326 18.5301 11.9385 18.2614 11.2913C17.9928 10.6441 17.5985 10.0566 17.1013 9.56266C15.0827 7.54666 11.5827 7.54666 9.56534 9.56266L11.448 11.4507C12.4613 10.44 14.208 10.4427 15.216 11.448Z",
    fill: "#68507C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ff4bc0f994961d14394172372d7ecef7.svg";
export { ForwardRef as ReactComponent };